import React from 'react';
import {SvgIcon, SvgIconProps} from '@mui/material';
import {ReactComponent as LimassolShape} from './limassol.svg';

const LIMASSOL_BLUE = '#3950a0';
const LIMASSOL_YELLOW = '#f4de33';
const LIMASSOL_BLACK = '#000000';

/**
 * Limassol Icon component using the detailed monochrome logo shape.
 */
export default function LimassolIcon({colored = false, sx, ...props}: {
    colored?: boolean;
} & SvgIconProps) {
    const shapeSx = colored ? {
        '& path#eye': {
            fill: LIMASSOL_BLACK,
        },
        '& path#disc': {
            fill: LIMASSOL_YELLOW,
        },
        '& path#inner-disc': {
            fill: LIMASSOL_BLUE,
        },
        '& path#mane1': {
            fill: LIMASSOL_BLACK,
        },
        '& path#mane2': {
            fill: LIMASSOL_BLACK,
        },
        '& path#mane3': {
            fill: LIMASSOL_BLACK,
        },
        '& path#mane4': {
            fill: LIMASSOL_BLACK,
        },
        '& path#tongue': {
            fill: LIMASSOL_BLACK,
        },
        '& path': {
            fill: LIMASSOL_BLACK,
        },
    } : {
        '& #disc': {
            display: 'none',
        },
        '& path': {
            fill: 'currentColor',
        },
    };

    return (
        <SvgIcon
            {...props}
            component={LimassolShape}
            inheritViewBox
            sx={[
                shapeSx,
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        />
    );
}
